"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openChangeHandler = void 0;
function openChangeHandler(prefix, onOpenChange) {
    return function (open) {
        if (open) {
            var panels_1 = Array.from(document.querySelectorAll(".".concat(prefix, "-panel-container")));
            var pointerEvents_1 = panels_1.map(function (panel) {
                var pointerEvents = panel.style.pointerEvents;
                panel.style.pointerEvents = 'none';
                return pointerEvents;
            });
            setTimeout(function () {
                panels_1.map(function (panel, index) {
                    panel.style.pointerEvents = pointerEvents_1[index];
                });
            }, 100);
        }
        return onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open);
    };
}
exports.openChangeHandler = openChangeHandler;
//# sourceMappingURL=utils.js.map